import { render, staticRenderFns } from "./CallingPlanRequest.vue?vue&type=template&id=197d2170&scoped=true"
import script from "./CallingPlanRequest.vue?vue&type=script&lang=js"
export * from "./CallingPlanRequest.vue?vue&type=script&lang=js"
import style0 from "./CallingPlanRequest.vue?vue&type=style&index=0&id=197d2170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d2170",
  null
  
)

export default component.exports